import CrudManager from "./CrudManager";
import { Star } from "lucide-react";

export default function TestimonialsAdmin() {
  return (
    <CrudManager
      name="testimonials" title="Testimonials" subtitle="Shown on the homepage (hidden if none active)"
      empty={{ name: "", role: "", quote: "", rating: 5, active: true, order: 99 }}
      fields={[
        { name: "name", label: "Name" },
        { name: "role", label: "Role / description" },
        { name: "quote", label: "Quote", type: "textarea" },
        { name: "rating", label: "Rating (1-5)", type: "number" },
        { name: "order", label: "Display order", type: "number" },
        { name: "active", label: "Active", type: "switch" },
      ]}
      renderSummary={(t) => (
        <>
          <div className="flex">{[...Array(t.rating || 5)].map((_, i) => <Star key={i} size={14} className="text-[#D4AF37] fill-[#D4AF37]" />)}</div>
          <p className="mt-2 text-sm text-white/80 italic line-clamp-3">"{t.quote}"</p>
          <div className="mt-2 text-sm text-[#D4AF37]">{t.name} <span className="text-white/40">· {t.role}</span></div>
          <div className="text-xs text-white/40">{t.active ? "Active" : "Hidden"}</div>
        </>
      )}
    />
  );
}
